import TICK from "components/icons/tick.svg";

import "./VerifiedTick.scss";

export const VerifiedTick = (props: {
  hint: string;
}): JSX.Element => {
  return (
    <div className="verifiedTick">
      <img
        src={TICK}
        alt=""
        title={props.hint}
      />
    </div>
  );
};
